<app-common-modal-form
  header="Generate a Payslip"
  icon="ic-generate-documents-20"
  confirmText="Download"
  closeText="Cancel"
  [isInvalid]="formArray.invalid"
  [isLoading]="isLoading()"
  (close)="close()"
  (confirm)="downloadPayslip()"
>
  <div>

    <ul class="p-0 m-0">
      @for (payslipFormGroup of formArray.controls; track payslipFormGroup) {
        <li
          class="form-group d-flex gap-2"
          [formGroup]="payslipFormGroup"
        >
          <div class="flex-grow-1">
            <app-autocomplete
              formControlName="reason"
              label="Reason"
              placeholder="Select reason"
              [isCombobox]="true"
              [valuePrimitive]="false"
              [options]="reasonOptionsList[$index]"
            />
          </div>

          <div class="paid-amount-wrapper">
            <app-input
              formControlName="paidAmount"
              label="Amount to Add"
              placeholder="Enter amount"
            />
          </div>
          @if (formArray.controls.length > 1) {
            <button
              type="button"
              class="mt-4 btn btn-secondary btn-icon"
              (click)="deletePayslipFormGroup($index)"
            >
              <i class="icon ic-close-20"></i>
            </button>
          }
        </li>
      }
    </ul>


    @if (formArray.controls.length == 1) {
      <div class="form-group">
        <button
          type="button"
          class="btn btn-secondary d-flex align-items-center gap-2"
          (click)="addPayslipFormGroup()"
        >
          <i class="icon ic-add-20"></i>
          <span>Add Reason</span>
        </button>
      </div>
    }

  </div>
</app-common-modal-form>
